import React from 'react';
import { InheritableElementProps } from '../_internal/components';
import Box from '../Box';
import Text from '../Text';
import IconYourStyleHangerInactive32 from '../icons/IconYourStyleHangerInactive32';

import styles from './imageUnavailable.module.scss';

interface BaseProps {
  /**
   * Text to display in component below inactive hanger icon
   */
  unavailableText?: string;
}

type Props = BaseProps;

export type ImageUnavailableProps = InheritableElementProps<'div', Props>;

/**
 * ImageUnavailable is a component that displays a placeholder image when the image is not available. Nothing fancy here.
 * It doesn't resize image, nor the text context: https://stitchfix.slack.com/archives/C025X8X8PGV/p1741711732272929
 */
const ImageUnavailable = ({
  unavailableText = 'Image Unavailable',
}: ImageUnavailableProps) => {
  return (
    <Box className={styles.default} data-testid="image-unavailable">
      <IconYourStyleHangerInactive32 color="gray-35" purpose="decorative" />
      <Text mt={0.75} color="gray-35" height="standard" scale="2">
        {unavailableText}
      </Text>
    </Box>
  );
};

export default ImageUnavailable;
